import {
  LessonPlanProperties,
  MultigradeLessonPlanProperties,
  ObjectiveProperties,
  QuizMakerSingleProperties,
  PageKey,
  SubjectExtensionsProperties,
  AnalogyContextualizerProperties,
  ActivitiesSingleProperties,
  CatchUpFridaysProperties,
  CerebroLessonPlanProperties,
  SummativeTestProperties,
  DllProperties,
  TopicExplorerProperties,
  EnergizerProperties,
  ElifProperties,
  ImageGenerationProperties,
  GenericUnpackingProperties,
  PptMakerProperties,
  UnitPlanProperties,
} from '../enums/pageKey';

export const LOCAL_STORAGE_PROPERTIES = {
  subject: 'subject',
  gradeLevel: 'gradeLevel',
  language: 'language',
  competency: 'competency',
  response: 'response',
  topic: 'topic',
  assessmentType: 'assessmentType',
  additionalInformation: 'additionalInformation',
  referenceText: 'referenceText',
  difficulty: 'difficulty',
  materials: 'materials',
  time: 'time',
};

export const objectiveLocalStorageProperties = {
  [ObjectiveProperties.subject]: 'objSubject',
  [ObjectiveProperties.gradeLevel]: 'objGradeLevel',
  [ObjectiveProperties.language]: 'objLanguage',
  [ObjectiveProperties.competency]: 'objCompetency',
  [ObjectiveProperties.cognitiveVerbs]: 'objCognitiveVerbs',
  [ObjectiveProperties.affectiveVerbs]: 'objAffectiveVerbs',
  [ObjectiveProperties.psychomotorVerbs]: 'objPsychomotorVerbs',
  [ObjectiveProperties.curriculumFramework]: 'objCurriculumFramework',
  [ObjectiveProperties.specificStandards]: 'objSpecificStandards',
  [ObjectiveProperties.objectives]: 'objBenchmark',
};

export const iplanObjectiveLocalStorageProperties = {
  [ObjectiveProperties.subject]: 'objSubject',
  [ObjectiveProperties.gradeLevel]: 'objGradeLevel',
  [ObjectiveProperties.language]: 'objLanguage',
  [ObjectiveProperties.competency]: 'objCompetency',
  [ObjectiveProperties.cognitiveVerbs]: 'objCognitiveVerbs',
  [ObjectiveProperties.psychomotorVerbs]: 'objPsychomotorVerbs',

  [ObjectiveProperties.affectiveValuesVerbs]: 'objAffectiveValuesVerbs',
  [ObjectiveProperties.affectiveValuesVerbs2]: 'objAffectiveValuesVerbs2',
  [ObjectiveProperties.affectiveValuesVerbs3]: 'objAffectiveValuesVerbs3',
  [ObjectiveProperties.affectiveAttitudesVerbs]: 'objAffectiveAttitudesVerbs',
  [ObjectiveProperties.affectiveAttitudesVerbs2]: 'objAffectiveAttitudesVerbs2',
  [ObjectiveProperties.affectiveAttitudesVerbs3]: 'objAffectiveAttitudesVerbs3',
  [ObjectiveProperties.valuesList]: 'objValuesList',
  [ObjectiveProperties.valuesList2]: 'objValuesList2',
  [ObjectiveProperties.valuesList3]: 'objValuesList3',
  [ObjectiveProperties.attitudesList]: 'objAttitudesList',
  [ObjectiveProperties.attitudesList2]: 'objAttitudesList2',
  [ObjectiveProperties.attitudesList3]: 'objAttitudesList3',
};

export const lessonPlanLocalStorageProperties = {
  [LessonPlanProperties.lessonFormat]: 'lpLessonFormat',
  [LessonPlanProperties.subject]: 'lpSubject',
  [LessonPlanProperties.gradeLevel]: 'lpGradeLevel',
  [LessonPlanProperties.objective]: 'lpObjective',
  [LessonPlanProperties.language]: 'lpLanguage',
  [LessonPlanProperties.objective2]: 'lpObjective2',
  [LessonPlanProperties.objective3]: 'lpObjective3',
  [LessonPlanProperties.objective4]: 'lpObjective4',

  // American Framework
  [LessonPlanProperties.specificStandards]: 'lpSpecificStandards',
  [LessonPlanProperties.curriculumFramework]: 'lpCurriculumFramework',
  [LessonPlanProperties.strategies]: 'lpStrategies',
  // montessori specific fields
  [LessonPlanProperties.title]: 'lpTitle',
  [LessonPlanProperties.classProgram]: 'lpClassProgram',
  [LessonPlanProperties.materials]: 'lpMaterials',
  [LessonPlanProperties.prerequisites]: 'lpPrerequisites',
  [LessonPlanProperties.keyArea]: 'lpKeyArea',
  [LessonPlanProperties.keyArea2]: 'lpKeyArea2',
  [LessonPlanProperties.keyArea3]: 'lpKeyArea3',
};

export const multigradeLessonPlanLocalStorageProperties = {
  [MultigradeLessonPlanProperties.lessonFormat]: 'mgLessonFormat',
  [MultigradeLessonPlanProperties.subject]: 'mgSubject',
  [MultigradeLessonPlanProperties.gradeLevel]: 'mgGradeLevel',
  [MultigradeLessonPlanProperties.objective]: 'mgObjective',
  [MultigradeLessonPlanProperties.language]: 'mgLanguage',
  [MultigradeLessonPlanProperties.objective2]: 'mgObjective2',
  [MultigradeLessonPlanProperties.objective3]: 'mgObjective3',
};

export const quizMakerSingleLocalStorageProperties = {
  [QuizMakerSingleProperties.subject]: 'quizSubject',
  [QuizMakerSingleProperties.gradeLevel]: 'quizGradeLevel',
  [QuizMakerSingleProperties.topic]: 'quizTopic',
  [QuizMakerSingleProperties.assessmentType]: 'quizAssessmentType',
  [QuizMakerSingleProperties.additionalInformation]:
    'quizAdditionalInformation',
  [QuizMakerSingleProperties.language]: 'quizLanguage',
  // American Framework
  [QuizMakerSingleProperties.specificStandards]: 'quizSpecificStandards',
  [QuizMakerSingleProperties.curriculumFramework]: 'quizCurriculumFramework',
  [QuizMakerSingleProperties.strategies]: 'quizStrategies',
  [QuizMakerSingleProperties.time]: 'quizTime',
  [QuizMakerSingleProperties.difficulty]: 'quizDifficulty',
  [QuizMakerSingleProperties.number]: 'quizNumber',
  [QuizMakerSingleProperties.objective]: 'quizObjective',
  [QuizMakerSingleProperties.objective2]: 'quizObjective2',
  [QuizMakerSingleProperties.objective3]: 'quizObjective3',
};

export const subjectExtensionsLocalStorageProperties = {
  [SubjectExtensionsProperties.subject]: 'seSubject',
  [SubjectExtensionsProperties.gradeLevel]: 'seGradeLevel',
  [SubjectExtensionsProperties.objective]: 'seObjective',
  [SubjectExtensionsProperties.language]: 'seLanguage',
};

export const activityLocalStorageProperties = {
  [ActivitiesSingleProperties.subject]: 'subject',
  [ActivitiesSingleProperties.gradeLevel]: 'gradeLevel',
  [ActivitiesSingleProperties.objective]: 'objective',
  [ActivitiesSingleProperties.difficulty]: 'difficulty',
  [ActivitiesSingleProperties.materials]: 'materials',
  [ActivitiesSingleProperties.time]: 'time',
  [ActivitiesSingleProperties.language]: 'language',
  //for american activity
  [ActivitiesSingleProperties.curriculumFramework]: 'curriculumFramework',
  [ActivitiesSingleProperties.specificStandards]: 'specificStandards',
  [ActivitiesSingleProperties.strategies]: 'strategies',
};

export const analogyContextualizerLocalStorageProperties = {
  [AnalogyContextualizerProperties.subject]: 'subject',
  [AnalogyContextualizerProperties.gradeLevel]: 'gradeLevel',
  [AnalogyContextualizerProperties.referenceText]: 'referenceText',
  [AnalogyContextualizerProperties.language]: 'language',
};

export const catchUpFridaysLocalStorageProperties = {
  [CatchUpFridaysProperties.gradeLevel]: 'gradeLevel',
  [CatchUpFridaysProperties.quarterlyTheme]: 'quarterlyTheme',
  [CatchUpFridaysProperties.sessionObjectives]: 'sessionObjectives',
  [CatchUpFridaysProperties.subTheme]: 'subTheme',
  [CatchUpFridaysProperties.subject]: 'subject',
  [CatchUpFridaysProperties.language]: 'language',
};

export const dailyLessonLogProperties = {
  [DllProperties.gradeLevel]: 'dllGradeLevel',
  [DllProperties.format]: 'dllFormat',
  [DllProperties.objectives]: 'dllObjectives',
  [DllProperties.subject]: 'dllSubject',
  [DllProperties.language]: 'dllLanguage',
};

export const cerebroLessonPlanProperties = {
  [CerebroLessonPlanProperties.gradeLevel]: 'lpGradeLevel',
  [CerebroLessonPlanProperties.courseTitle]: 'courseTitle',
  [CerebroLessonPlanProperties.courseTopic]: 'courseTopic',
  [CerebroLessonPlanProperties.contentStandard]: 'contentStandard',
  [CerebroLessonPlanProperties.performanceStandard]: 'performanceStandard',
  [CerebroLessonPlanProperties.learningCompetencies]: 'learningCompetencies',
};
export const summativeTestProperties = {
  [SummativeTestProperties.gradeLevel]: 'gradeLevel',
  [SummativeTestProperties.language]: 'language',
  [SummativeTestProperties.subject]: 'subject',
  [SummativeTestProperties.topics]: 'topics',
  [SummativeTestProperties.format]: 'format',
  [SummativeTestProperties.curriculum]: 'curriculum',
  [SummativeTestProperties.assessmentTypes]: 'assessmentTypes',
  [SummativeTestProperties.standard]: 'stSpecificStandard',
  [SummativeTestProperties.curriculumFramework]: 'stCurriculumFramework',
  [SummativeTestProperties.strategies]: 'strategies',
};

export const unitPlanProperties = {
  [UnitPlanProperties.subject]: 'subject',
  [UnitPlanProperties.topic]: 'topic',
  [UnitPlanProperties.format]: 'format',
  [UnitPlanProperties.gradeLevel]: 'gradeLevel',
  [UnitPlanProperties.theme]: 'theme',
  [UnitPlanProperties.context]: 'context',
  [UnitPlanProperties.attributes]: 'attributes',
  [UnitPlanProperties.goals]: 'goals',
};

export const topicExplorerProperties = {
  [TopicExplorerProperties.topic]: 'topic',
  [TopicExplorerProperties.explorerType]: 'teExplorerType',
  [TopicExplorerProperties.subject]: 'teSubject',
  [TopicExplorerProperties.gradeLevel]: 'teGradeLevel',
  [TopicExplorerProperties.itemToUnpack]: 'teItemToUnpack',
};
export const energizerProperties = {
  [EnergizerProperties.gradeLevel]: 'enGradeLevel',
  [EnergizerProperties.topic]: 'enTopic',
};
export const elifProperties = {
  [ElifProperties.topic]: 'topic',
};
export const photoBoothProperties = {
  [ImageGenerationProperties.topic]: 'topic',
  [ImageGenerationProperties.subject]: 'subject',
  [ImageGenerationProperties.design]: 'design',
};
export const pptMakerProperties = {
  [PptMakerProperties.sections]: 'sections',
  [PptMakerProperties.slideNumber]: 'slideNumber',
  [PptMakerProperties.doc]: 'doc',
};

export const genericUnpackingLocalStorageProperties = {
  [GenericUnpackingProperties.subject]: 'guSubject',
  [GenericUnpackingProperties.gradeLevel]: 'guGradeLevel',
  [GenericUnpackingProperties.unpackType]: 'guUnpackType',
  [GenericUnpackingProperties.itemToUnpack]: 'guItemToUnpack',
};

export const pageContentLocalStorageProperties = {
  [PageKey.lessonPlan]: lessonPlanLocalStorageProperties,
  [PageKey.multigradeLessonPlan]: multigradeLessonPlanLocalStorageProperties,
  [PageKey.objective]: objectiveLocalStorageProperties,
  [PageKey.quizMakerSingle]: quizMakerSingleLocalStorageProperties,
  [PageKey.subjectExtention]: subjectExtensionsLocalStorageProperties,
  [PageKey.analogyContextualizer]: analogyContextualizerLocalStorageProperties,
  [PageKey.activities]: activityLocalStorageProperties,
  [PageKey.catchUpFridays]: catchUpFridaysLocalStorageProperties,
  [PageKey.dailyLessonLog]: dailyLessonLogProperties,
  [PageKey.cerebroLessonPlan]: cerebroLessonPlanProperties,
  [PageKey.summativeTest]: summativeTestProperties,
  [PageKey.unitPlan]: unitPlanProperties,
  [PageKey.topicExplorer]: topicExplorerProperties,
  [PageKey.energizer]: energizerProperties,
  [PageKey.elif]: elifProperties,
  [PageKey.photoBooth]: photoBoothProperties,
  [PageKey.pptMaker]: pptMakerProperties,
  [PageKey.genericUnpacking]: genericUnpackingLocalStorageProperties,
  [PageKey.iplanObjective]: iplanObjectiveLocalStorageProperties,
};

export const RECENT_GENERATIONS_STORAGE = {
  recentGenerationsList: 'recentGenerationsList',
  maxRecentGenerations: 10,
} as const;

export const GENERATION_CONTENT_PREFIX = 'generation_content_';
